<template lang='pug'>
  .section
    .container.grid
      .field
        h1.is-size-3.has-text-black.has-text-centered Permissão para uso do Pontotel Web
      InputText.has-text-centered(v-focus="", v-model="name", autocomplete="off",
        @keyup.enter="createBrowserRecord", pattern=".{3,}", required="true", label="Nome")

      InputText.has-text-centered(, v-model="reason", autocomplete="off",
        @keyup.enter="createBrowserRecord", pattern=".{3,}", required="true", label="Motivo")

      .field
        .control.has-text-centered.mt3(v-if="!onlyMineGroup")
          label.to-click
            input(type='radio', value='group', v-model='kind')
            |   Para equipe &nbsp;
          label.to-click
            input(type='radio', value='mine', v-model='kind')
            |   Para mim

        span(v-if="kind === 'group' && !onlyMineGroup")
          label Locais de trabalho
            MultiSelect(filterText="filtrar locais de trabalho", useState="chooseCompany/companies", :callback="loadCompanies")

        span(v-else)
          InputText.has-text-centered(v-model="pwd", autocomplete="off", type="password"
            @keyup.enter="createBrowserRecord", required="true", label="Digite sua senha de acesso", :password="true")

      .field
        Button3d(@click="createBrowserRecord", color="primary", size="large", :block="true") Selecionar

</template>

<script>
import MultiSelect from '../../common/MultiSelect/MultiSelect.vue'
import { mapActions, mapState } from 'vuex'

export default {
  mounted: function () {
    this.allCompanies = { ...this.$store.state.chooseCompany.companies }
    this.$store.commit('chooseCompany/resetState')
  },
  computed: {
    ...mapState('chooseCompany', ['onlyMineGroup']),
    kind: {
      set (value) {
        this.$store.commit('chooseCompany/kind', value)
      },
      get () {
        return this.$store.state.chooseCompany.kind
      }
    },
    name: {
      get () {
        return this.$store.state.chooseCompany.name
      },
      set (value) {
        this.$store.commit('chooseCompany/name', value)
      }
    },
    reason: {
      get () {
        return this.$store.state.chooseCompany.reason
      },
      set (value) {
        this.$store.commit('chooseCompany/reason', value)
      }
    },
    pwd: {
      get () {
        return this.$store.state.chooseCompany.pwd
      },
      set (value) {
        this.$store.commit('chooseCompany/pwd', value)
      }
    }
  },
  methods: {
    ...mapActions('chooseCompany', ['createBrowserRecord']),
    loadCompanies (options) {
      if (options.search) {
        let listFiltered = this.allCompanies.loaded.filter((item) => {
          if (item.name.includes(options.search)) {
            return item
          }
        })
        this.$store.commit('chooseCompany/companies', {loaded: listFiltered})
      } else {
        this.$store.commit('chooseCompany/companies', {loaded: this.allCompanies.loaded})
      }
    }
  },
  components: {
    MultiSelect
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid {
  display: grid;
  grid-template-columns: [xl-start] 1fr 1.5rem [md-start] minmax(0, 624px) [md-end] 1.5rem 1fr [xl-end];
}
.grid * { grid-column: md; }
.grid-xl * { grid-column: xl; }
</style>
